import React from 'react';
import IconButton from '@mui/material/IconButton';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import { useColorMode } from '../ColorModeContext';

const ThemeToggle = () => {
  const { toggleColorMode, mode } = useColorMode();

  return (
    <IconButton
      onClick={toggleColorMode}
      color="inherit"
      aria-label="toggle dark mode"
      sx={{
        opacity: 0.7,
        transition: 'opacity 0.2s ease',
        '&:hover': {
          opacity: 1,
        },
      }}
    >
      {mode === 'dark' ? <Brightness7Icon /> : <Brightness4Icon />}
    </IconButton>
  );
};

export default ThemeToggle;
